// extracted by mini-css-extract-plugin
export default {"accordionTrigger":"Accordion_accordionTrigger__sH-07","accordionContent":"Accordion_accordionContent__oLE+U","accordionIcon":"Accordion_accordionIcon__kFdv5"};